// extracted by mini-css-extract-plugin
module.exports = {"select_group":"MultiSelectGroup_select_group__1JQjF","select":"MultiSelectGroup_select__Gjtvv","select_text":"MultiSelectGroup_select_text__214mI"};